import { render, staticRenderFns } from "./AddTtsResourceModal.vue?vue&type=template&id=ee6f8154&scoped=true"
import script from "./AddTtsResourceModal.vue?vue&type=script&lang=js"
export * from "./AddTtsResourceModal.vue?vue&type=script&lang=js"
import style0 from "./AddTtsResourceModal.vue?vue&type=style&index=0&id=ee6f8154&prod&lang=scss"
import style1 from "./AddTtsResourceModal.vue?vue&type=style&index=1&id=ee6f8154&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6f8154",
  null
  
)

export default component.exports